import React from 'react'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import Icon from '@forwardflow/ui/Icons'

dayjs.extend(duration)

interface MessageItemProps {
   item: any
}

export const AppointmentMissedItem: React.FC<MessageItemProps> = ({ item }) => {
   return (
      <div className="flex flex-col items-end justify-end gap-x-2">
         <div className="flex items-center justify-between bg-[#643338] py-4 px-8 w-full gap-y-4 text-[12px]">
            <div className="flex items-center gap-x-4">
               <Icon name="AppointmentMissedSmall" className="fill-white" />
               <p className="font-medium">Appointment Missed</p>
               <p className="font-medium">{item?.content}</p>
            </div>
            <p>{dayjs(item?.ts).format('h:mm A, D MMM YYYY')}</p>
         </div>
      </div>
   )
}
